import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
 * Service for managing client services.
 */
@Injectable()
export class ClientServicesService {

    constructor(private requestService: ObservableRequestService) { }

    listClientServices(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.LIST_CLIENT_SERVICES);
    }

    fetchClientServices(id: number): Observable<any> {
        const url = ConstantsService.PROVIDED_CLIENT_SERVICES + '/' + id;
        return this.requestService.getRequest(url);
    }

    fetchServicesDescription(id: number): Observable<any> {
        const url = ConstantsService.SERVICES_DESCRIPTION + '/' + id;
        return this.requestService.getRequest(url);
    }

    fetchDocumentsDescription(id: number): Observable<any> {
        const url = ConstantsService.DOCUMENTS_DESCRIPTION + '/' + id;
        return this.requestService.getRequest(url);
    }

    fetchDocumentsByDocType(entityId: number, docTypeId: number) {
        const url = ConstantsService.FETCH_DOCUMENT_BYDOCTYPE + '/' + entityId + '/' + docTypeId;
        return this.requestService.getRequest(url);
    }

    updateClientServices(body: Object): Observable<any> {
        return this.requestService
            .postRequest(ConstantsService.PROVIDED_CLIENT_SERVICES,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };

    updateServicesDescription(body: Object): Observable<any> {
        return this.requestService
            .putRequest(ConstantsService.SERVICES_DESCRIPTION,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };

    updateDocumentsDescription(body: Object): Observable<any> {
        return this.requestService
            .postRequest(ConstantsService.DOCUMENTS_DESCRIPTION,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };

  deleteDocument(documentId): Observable<any> {
    const url = ConstantsService.DOCUMENT + '/' + documentId;
    return this.requestService.deleteRequest(
      url,
      this.requestService.serialize(''),
      this.requestService.getJSONContentType());
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/services/client-services.service.ts